import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 *
 * Automatically scrolls to the top of the page when the route changes.
 * This ensures that navigating to a new page always starts at the top,
 * mimicking traditional multi-page website behavior.
 *
 * Usage: Place inside BrowserRouter, before <Routes>
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes
    // Using window.scrollTo for maximum browser compatibility
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // This component doesn't render anything
}
